import { createClient } from '@supabase/supabase-js';

// Supabase config - usar variaveis de ambiente com fallback para projeto womom
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://hfdjlzcevwukhgvygmps.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhmZGpsemNldnd1a2hndnlnbXBzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkyOTMyODcsImV4cCI6MjA5NDg2OTI4N30.2oEtoUC8vMjkloRJwqiy8jngWHk5Ov7WanRXxNStops';

// Singleton pattern - garantir apenas uma instancia do cliente
let supabaseInstance = null;

export const getSupabase = () => {
  if (!supabaseInstance) {
    supabaseInstance = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storageKey: 'womom-auth-token'
      }
    });
  }
  return supabaseInstance;
};

// Export padrao para compatibilidade
export const supabase = getSupabase();
